import {endpointsMap, IValidateOptions, IValidateResponse} from './ICustomShopperApplepay';

import AbstractCustomShopperAPI from '../AbstractCustomShopperAPI';
import {ICustomApiConfig} from '../ICustomApiConfig';

/**
 * Represents CustomShopperApplepay
 */
class CustomShopperApplepay extends AbstractCustomShopperAPI {
	/**
	 * @constructor
	 * @param {ICustomApiConfig} config - API Config
	 */
	constructor(config: ICustomApiConfig) {
		super(config);
	}

	/**
	 * Validates an Applepay request
	 * @param {IValidateOptions} fetchOptions - options to pass to API Call
	 * @param {boolean} throwOnError - throw error if api returns error
	 *
	 * @returns {IValidateResponse} - Array of customer groups
	 */
	public async applePayValidation(fetchOptions: IValidateOptions, throwOnError?: boolean): Promise<IValidateResponse> {
		const response: IValidateResponse = await this.callCustomEndpoint<IValidateResponse>(
			fetchOptions,
			endpointsMap.VALIDATE
		);

		if (throwOnError && (!response.shippingContact.valid || !response.billingContact.valid)) {
			let error = '';

			if (!response.shippingContact.valid) {
				error += response.shippingContact.custom.errorMessage + '\n';
			}

			if (!response.billingContact.valid) {
				error += response.billingContact.custom.errorMessage + '\n';
			}

			throw new Error(error || 'Invalid request');
		}

		return response;
	}
}

export default CustomShopperApplepay;
